module.exports = " <path :d=set(data) :stroke-width=strokeWidth :stroke=stroke _v-4fd6712d=\"\"></path> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-4fd6712d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Line.vue
// module id = 758
// module chunks = 2